import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store";

export interface DashboardState {
  isDocumentUploadEnabled: boolean;
}

const initialState: DashboardState = {
  isDocumentUploadEnabled: true
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    disableDocumentUpload: (state) => {
      return {...state, isDocumentUploadEnabled: false};
    },
    enableDocumentUpload: (state) => {
      return {...state, isDocumentUploadEnabled: true};
    }
  }
});

export const {
  disableDocumentUpload,
  enableDocumentUpload
} = dashboardSlice.actions;

export const isDocumentUploadEnabled = (state: RootState): boolean => state.dashboard.isDocumentUploadEnabled;

export default dashboardSlice.reducer;